import React, { useState } from "react";
import { getRuta, simpleMessage } from "../../../../helpers/Helpers";
import moment from "moment/moment";
import {
  BotonGenerar,
  FormularioSelector,
  RangoFechas,
  SelectorGestor,
  validarRangoFechas,
} from "../../../../components/reportes/selector";

const SelectorDesembolsos = () => {
  const [selectedGestor, setSelectedGestor] = useState("t");
  var date = new Date();
  const [fechaDesde, setFechaDesde] = useState(
    new Date(date.getFullYear(), date.getMonth(), 1)
  );
  const [fechaHasta, setFechaHasta] = useState(date);

  let ruta = getRuta();

  const verReport = () => {
    const errorFechas = validarRangoFechas(fechaDesde, fechaHasta);
    if (errorFechas) {
      simpleMessage(errorFechas, "error");
      return;
    }

    var params = `${selectedGestor}/${moment(fechaDesde).format(
      "YYYY-MM-DD"
    )}/${moment(fechaHasta).format("YYYY-MM-DD")}`;
    window.open(`${ruta}/r-desembolsos/${params}`);
  };

  return (
    <FormularioSelector>
      <SelectorGestor value={selectedGestor} onChange={setSelectedGestor} />

      <RangoFechas
        desde={fechaDesde}
        hasta={fechaHasta}
        onChangeDesde={setFechaDesde}
        onChangeHasta={setFechaHasta}
      />

      <BotonGenerar onClick={verReport} />
    </FormularioSelector>
  );
};
export default SelectorDesembolsos;
